import "@/application/myAppEnv"
import '@/http';
import '@/scss/app.scss';

import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import BaseMixin from '@/mixins/BaseMixin';
import router from './router'
import i18n from './localization'
import vuetify from './plugins/vuetify';
import AuthService from '@/utils/AuthService';

Vue.mixin(BaseMixin);
new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: (h) => h(App),
    mounted() {
        if (!window.location.hash.includes('statics')) {
            AuthService.ensureUserIsLoggedIn();
        }
        else {
            console.log('Ignore login...')
        }
    }
}).$mount("#app");